var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{style:({width: '800px',height: '400px'}),attrs:{"id":'myChart' + _vm.suffix}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }